import { render, staticRenderFns } from "./dossier-detail-component-general-information.vue?vue&type=template&id=c28ef268&scoped=true"
import script from "./dossier-detail-component-general-information.vue?vue&type=script&lang=ts"
export * from "./dossier-detail-component-general-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28ef268",
  null
  
)

export default component.exports